export const ReservationDB = [
    {
        id: 1,
        date: "2025-07-08",
        time: "17:00",
        guests: 2,
        occasion: "Birthday"
    },
    {
        id: 2,
        date: "2025-07-08",
        time: "18:00",
        guests: 4,
        occasion: "Anniversary"
    },
    {
        id: 3,
        date: "2025-07-09",
        time: "19:00",
        guests: 3,
        occasion: "Graduation"
    },
    {
        id: 4,
        date: "2025-07-09",
        time: "20:00",
        guests: 5,
        occasion: "Wedding"
    },
    {
        id: 5,
        date: "2025-07-10",
        time: "21:00",
        guests: 6,
        occasion: "Other"
    },
    {
        id: 6,
        date: "2025-07-10",
        time: "22:00",
        guests: 2,
        occasion: "Birthday"
    }
];

export const loginData = [
    {
        id: "100",
        username: "Admin@gmail.com",
        password: "Admin@gmail.com"
    }
];